import React from "react";

import { Button } from "primereact/button";

type ArrowNavigationButtonsProps = {
  isPrevDisabled: boolean;
  isNextDisabled: boolean;
  prevTooltip: string;
  nextTooltip: string;
  onPrev: () => void;
  onNext: () => void;
};

const ArrowNavigationButtons = ({
  isPrevDisabled,
  isNextDisabled,
  prevTooltip,
  nextTooltip,
  onPrev,
  onNext,
}: ArrowNavigationButtonsProps) => (
  <>
    <Button
      icon="pi pi-arrow-left"
      className="p-button-text"
      disabled={isPrevDisabled}
      tooltip={prevTooltip}
      tooltipOptions={{ position: "bottom" }}
      onClick={onPrev}
    />
    <Button
      icon="pi pi-arrow-right"
      className="p-button-text"
      disabled={isNextDisabled}
      tooltip={nextTooltip}
      tooltipOptions={{ position: "bottom" }}
      onClick={onNext}
    />
  </>
);

export default ArrowNavigationButtons;
